import { render, staticRenderFns } from "./comment_shop.vue?vue&type=template&id=606bcd52&scoped=true&"
import script from "./comment_shop.vue?vue&type=script&lang=js&"
export * from "./comment_shop.vue?vue&type=script&lang=js&"
import style0 from "./comment_shop.vue?vue&type=style&index=0&id=606bcd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bcd52",
  null
  
)

export default component.exports